var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detailsCommon',{attrs:{"boxList":_vm.boxList,"form":_vm.info}})
}
var staticRenderFns = []

export { render, staticRenderFns }